<div class="container flex w-full flex-col items-center">
  <rd-shared-breadcrumb
    class="ml-4 self-start lg:ml-0"
    [displayModeDesktop]="'stacked'"
    [displayModeMobile]="'stacked'"
    [breadcrumbText]="'redeem_cash_v2.back_to_selection' | translate"
    [loading]="false"
    [redirectURL]="'/redeem_cash/checkout'">
  </rd-shared-breadcrumb>

  <div class="desktop-container w-full px-4 lg:px-0">
    <rd-shared-alert
      alertTheme="error"
      icon="error"
      class="mb-6 w-full px-4 lg:px-0"
      *ngIf="error$ | async">
      <div class="w-full">
        <p class="m-0 typo-text-mobile lg:typo-text-desktop" aria-live="polite">
          {{ 'membership.error.validation_error' | translate }}
        </p>
      </div>
    </rd-shared-alert>
    <div
      class="max-width info rounded-md flex w-full justify-center justify-between px-4 py-5 lg:mx-0">
      <div class="flex flex-col justify-around">
        <h1 class="typo-text-mobile lg:typo-text-desktop">
          {{ 'auto_redemption.redeem_cash_v2.chosen_redemption' | translate }}
        </h1>
        <p
          class="title typo-text-emphasis-1-mobile lg:typo-text-emphasis-1-desktop">
          {{ (cashBackLoyaltyProgram$ | async)?.shortName }}
        </p>
      </div>
    </div>
    <form (ngSubmit)="submit()" class="flex flex-col">
      <ng-container
        *ngIf="(formType$ | async) !== enrollmentFormType.NoCreditCard">
        <h2
          class="title self-start typo-heading-3-mobile lg:typo-heading-3-desktop">
          {{
            'auto_redemption.redeem_cash_v2.choose_setting.title' | translate
          }}
        </h2>
        <ng-container *ngIf="cashBackLoyaltyProgram$ | async">
          <rd-auto-redemption-rc-specific-amount-form
            [loyaltyProgram]="cashBackLoyaltyProgram$ | async"
            [homeLoyaltyCurrency]="homeLoyaltyCurrency$ | async"
            [targetLoyaltyCurrency]="
              (cashBackLoyaltyProgram$ | async)?.loyaltyCurrency
            "
            [targetTransferRate]="
              (cashBackLoyaltyProgram$ | async)?.transferRate
            "></rd-auto-redemption-rc-specific-amount-form>
        </ng-container>
      </ng-container>

      <h2
        class="title mt-4 mb-4 self-start typo-heading-3-mobile lg:typo-heading-3-desktop">
        {{ 'enrollment.form.title' | translate }}
      </h2>
      <rd-anz-enrollment-form></rd-anz-enrollment-form>
      <rd-shared-button
        [dataTestid]="'anz-rc-ar-enrollment-button-submit'"
        *ngIf="(formType$ | async) !== enrollmentFormType.NoCreditCard"
        class="submit-button my-6 self-center"
        [isDisabled]="
          (disableButtonState$ | async) || (rcForm?.pending$ | async)
        "
        [buttonText]="'auto_redemption.transfer_v2.review.text' | translate"
        buttonTheme="primary"
        buttonType="submit"></rd-shared-button>
    </form>
  </div>
</div>
